import { render, staticRenderFns } from "./ProyectosDetalle.vue?vue&type=template&id=56bd6c25&scoped=true"
import script from "./ProyectosDetalle.vue?vue&type=script&lang=js"
export * from "./ProyectosDetalle.vue?vue&type=script&lang=js"
import style0 from "./ProyectosDetalle.vue?vue&type=style&index=0&id=56bd6c25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bd6c25",
  null
  
)

export default component.exports